import React from 'react';

const BimVdc = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['view_in_ar', '3d_rotation', 'architecture', 'my_location', 'cloud_sync', 'tablet_mac', 'precision_manufacturing', 'engineering'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              BIM - VDC/Trimble
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Advanced Building Information Modeling and Virtual Design & Construction
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Building Information Modeling */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Building Information Modeling</h2>
            <p>Real field experience meets cutting-edge technology</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                In addition to being proficient in BIM/CAD, the Bel-Aire Modeling Team Members have real field experience. Each has served their apprenticeships and at a minimum are Journeyman of their respective Sheet Metal, Pipe, or Plumbing trades. Our BIM/CAD team brings well over <strong style={{color: 'var(--accent-blue)'}}>100-years of combined industry experience</strong> to Bel-Aire Mechanical.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                Bel-Aire Mechanical is highly skilled in the production of Building Model Design and Virtual Construction. Each model requires its own unique approach to develop a highly detailed, digital 3D model representation. The completed model will be used to maximize trade coordination and field productivity.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [BIM Team at Work Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '0'}}>
                This minimizes the need for RFI's and potential change orders thus streamlining the construction process and improving the project schedule.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our BIM Tools */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Our BIM Tools</h2>
            <p>State-of-the-art technology and software solutions</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [High-Power Workstation Setup Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                With the use of our <strong style={{color: 'var(--accent-blue)'}}>high-power Workstation computers and Ultra-wide monitors</strong> (to keep the width of the model in one view width), Bel-Aire Mechanical's 3D BIM/CAD department is currently modeling using Autodesk Architecture, Engineering, and Construction (AEC) Collection, including Autodesk Fabrication CAMmep to produce CNC files.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Autodesk AEC Collection</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Bel-Aire Mechanical utilizes this specialized Building Information Modeling (BIM) software in a real value-added design process that doesn't just mimic drafting, but allows for true digital representation of the building process to facilitate exchange and interoperability of information in a digital format.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Virtual Design and Construction */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Virtual Design and Construction</h2>
            <p>Pre-construction coordination for optimal project outcomes</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                During the construction of any project, the coordination of the trades is an integral part of the process, especially with respect to the mechanical and electrical trades.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                  <span className="material-icons" style={{fontSize: '1.5rem'}}>precision_manufacturing</span>
                  Virtual Coordination Benefits
                </h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  This coordination works best when accomplished before the construction begins via virtual design. Bel-Aire Mechanical can take ownership of the composite virtual model to perform clash resolution thus eliminating any coordination that would need to be performed in the field. This is a huge timesaver for the field personnel and is critical in meeting the time restraints placed on today's projects.
                </p>
              </div>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Virtual Design Process Image]
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Trimble Total Station & Scanner */}
      <section className="section" style={{background: 'var(--secondary-light)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Trimble Total Station & Scanner</h2>
            <p>Coordination with Other Trades - Leading the way</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Trimble Equipment in Use Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Bel-Aire Mechanical utilizes a <strong style={{color: 'var(--accent-blue)'}}>Trimble Total Station</strong> to transfer modeled points to the field for the exact layout of sleeves, hangers and block outs.
              </p>
              
              <div style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', border: '2px solid var(--accent2-red)'}}>
                <h3 style={{fontSize: '1.5rem', marginBottom: '1.5rem', color: 'var(--accent2-red)'}}>Trade Coordination Leadership</h3>
                <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                  We are also well versed in the coordination of our BIM models with the other trades. As a mechanical contractor with the most content on a project we usually take a lead role in coordinating a clash free model.
                </p>
                <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', margin: 0}}>
                  We believe in working closely with the other trades to make sure this happens by identifying problem areas & communicating with them directly. We also have taken ownership of the coordination model on past projects & were responsible for not only identifying each clash but also assigning responsibility for those clashes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: BIM Information in the Field */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>BIM Information in the Field</h2>
            <p>Advanced technology for real-time project collaboration</p>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '2rem'}}>
              <div className="image-placeholder" style={{minHeight: '350px'}}>
                [Field Technology Center Image]
              </div>
              
              <div>
                <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                  Our project field sites utilize <strong style={{color: 'var(--accent-blue)'}}>Huddle systems in our trailers and our custom Field Technology Centers (FTC)</strong> in the construction area to review drawings and other project related documents in a collaborative environment with key project personnel.
                </p>
                
                <div style={{background: 'linear-gradient(90deg, rgba(0, 104, 166, 0.1) 0%, rgba(171, 22, 54, 0.1) 100%)', padding: '2rem', borderRadius: '8px', borderLeft: '4px solid var(--accent-blue)'}}>
                  <p style={{fontSize: '1.15rem', lineHeight: '1.7', color: 'var(--primary-black)', fontWeight: '600', margin: 0}}>
                    "Bluebeam Studio Project is tied in with our Huddle and FTC's to easily retrieve drawings and documents that are stored in the cloud."
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bim-tech-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="bim-tech-card bim-tech-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons bim-tech-icon" style={{fontSize: '2.5rem', opacity: 0.9}}>cloud_sync</span>
                <div className="bim-tech-content">
                  <h3 className="bim-tech-title" style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Bluebeam Studio Session</h3>
                  <p className="bim-tech-text" style={{fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)', margin: 0}}>Real time markups of documents during collaborative working meetings</p>
                </div>
              </div>
              
              <div className="bim-tech-card bim-tech-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons bim-tech-icon" style={{fontSize: '2.5rem', opacity: 0.9}}>tablet_mac</span>
                <div className="bim-tech-content">
                  <h3 className="bim-tech-title" style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>Autodesk BIM 360 Field</h3>
                  <p className="bim-tech-text" style={{fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)', margin: 0}}>iPad app for QA personnel to verify work and avoid conflicts</p>
                </div>
              </div>
            </div>
            
            <div style={{background: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', marginTop: '2rem', border: '2px solid var(--accent2-red)'}}>
              <h3 style={{fontSize: '1.5rem', marginBottom: '1.5rem', color: 'var(--accent2-red)'}}>Quality Assurance Process</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', margin: 0}}>
                Our QA personnel use Autodesk's BIM 360 Field app on iPads to walk the project site and compare real-time field views to the BIM drawings to verify work, identify possible collisions, and avoid conflicts, thus assuring true <strong style={{color: 'var(--accent2-red)'}}>"Quality Assurance"</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BimVdc;
